const shadows = {
  outline: "0 0 0 3px rgba(20, 204, 82, 0.6)",
};

export default shadows;
